import axios from '../../services/axios';

// Payload attendu par l'endpoint public `POST /api/internal/contact` (contrôleur
// `contactEmail`). ⚠ Les clés sont en FRANÇAIS (le contrôleur lit `nom`/`email`/`message`,
// pas `name`/`firstname`). `product: 'graphdebate'` déclenche le sujet email `[Graphdebate]`.
// L'endpoint n'a AUCUN champ « motif » ni « tenant » → le motif est préfixé et le nom du
// tenant est injecté dans `message` en amont (cf. ContactForm), pas ici.
export type ContactFormPayload = {
  nom: string;
  email: string;
  message: string;
  product: 'graphdebate';
};

// Réutilise l'instance axios partagée (`graphCommentInstance`, baseURL = apiUrl). L'URL est
// relative à la baseURL, sans slash initial (convention des autres call-sites REST du repo).
// L'endpoint répond `200 {msg:'ok'}` en succès, `400 {msg:'error_name'|'error_email'|'error_msg'}`
// en validation, `429 {error:'Too many requests'}` si le rate-limit dédié (B7_08/D44) est atteint.
export const postContactForm = async (payload: ContactFormPayload) => {
  const { data } = await axios.post('api/internal/contact', payload);
  return data;
};
